export default __webpack_public_path__ + "static/subCh01.1-0c95ef32543140b9dc69d9abd50a338c.png";